import React, { useEffect, useState } from "react";
import SAYearWiseMaster from "../../7ALoading/Seven A Summary/SAYearWiseMaster";
import { FaCheckCircle } from "react-icons/fa";
import { IoMdDownload } from "react-icons/io";
import { MdCloudDownload, MdDownloadForOffline } from "react-icons/md";
import axios from "axios";
import Loading from "../../../Extra/Loading";
import { flattenData, flattenDeep } from "../../../Utilitie";
import SAMonthWiseMaster from "../../7ALoading/Seven A Summary/SAMonthWiseMaster";
import SAStationWiseMaster from "../../7ALoading/Seven A Summary/SAStationWiseMaster";
import EverBestMnthWiseSa from "./EverBestMnthWiseSa";
const EverBest7aSummary = ({
  data,
  setMoreData,
  availableYear,
  yearsInData,
}) => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const pages = ["Year wise", "Month Wise"];
  const [finalData, setFinalData] = useState(null);
  const [activePage, setActivePage] = useState("Year wise");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setFinalData(flattenDeep(data));
  }, [data]);
  const fetchData = async (year) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}data7aloading?finYears=${year}`,
      );
      setMoreData(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <div className="fade-in-up">
      {loading && <Loading />}
      <div className="row  me-2 ms-2">
        <div className="col-md-2 border newUiBody">
          {" "}
          <h5>Reports</h5>
          <hr />
          <div className="d-flex flex-column ">
            {pages.map((page) => {
              return (
                <button
                  onClick={() => setActivePage(page)}
                  className={`btn btn-sm btn-outline-dark Subject  m-2 ${
                    activePage === page && "active"
                  }`}
                >
                  {page}
                </button>
              );
            })}
          </div>
        </div>
        <div className="col-md-10 border newUiBody">
          <div className="row">
            <div className="col-md-8 border-end">
              {" "}
              <h5>{activePage}</h5>{" "}
            </div>
            <div className="col-md-4 ">
              <div className="d-flex text-wrap align-items-center">
                <MdCloudDownload
                  style={{ color: "#048a28ff", fontSize: "23px" }}
                />{" "}
                Get Data {"  "}
                <div
                  className="ms-1 pt-2"
                  style={{
                    fontSize: "12px",
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    display: "block", // (or inline-block)
                  }}
                >
                  {availableYear.map((year, i) => (
                    <button
                      onClick={() => fetchData(year)}
                      disabled={yearsInData.includes(year)}
                      style={{
                        cursor: "pointer",
                      }}
                      className={`position-relative btn btn-sm btn-outline-${
                        yearsInData.includes(year) ? "dark" : "success"
                      } me-2   ${
                        availableYear.includes(year === "2025_26" && year) &&
                        "active"
                      } `}
                      key={i}
                    >
                      {" "}
                      {year}
                      <span
                        className={`position-absolute top-0 start-100 translate-middle bg-white  rounded-circle `}
                      >
                        {yearsInData.includes(year) ? (
                          <FaCheckCircle
                            style={{ color: "#d10505ff", fontSize: "18px" }}
                          />
                        ) : (
                          <MdDownloadForOffline
                            style={{ color: "#048a28ff", fontSize: "23px" }}
                          />
                        )}
                      </span>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <hr className="mt-1 p-0" />
          {activePage === "Year wise" && (
            <SAYearWiseMaster data={finalData} />
          )}{" "}
          {activePage === "Month Wise" && (
            <EverBestMnthWiseSa data={finalData} />
          )}
        </div>
      </div>
    </div>
  );
};
export default EverBest7aSummary;
